import React from 'react';
import BeforeAfterSlider from './BeforeAfterSlider';

function ServicePage({ service, projects }) {
  const serviceData = JSON.parse(service);
  const projectsData = JSON.parse(projects);
  const featuredProject = projectsData[0];

  return (
    <div className="py-8 md:py-12">
      {/* Hero Section */}
      <section className="container mx-auto px-4 text-center mb-12">
        <div className="text-6xl mb-4">{serviceData.icon}</div>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-900 mb-4">
          {serviceData.name}
        </h1>
        <p className="text-lg md:text-xl text-brand-700 max-w-3xl mx-auto">
          {serviceData.long_description}
        </p>
      </section>

      {/* Before/After Section */}
      {featuredProject && (
        <section className="container mx-auto px-4 mb-12">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-brand-900 text-center mb-6">
              See Our Results
            </h2>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <BeforeAfterSlider
                beforeImage={featuredProject.before_image_url}
                afterImage={featuredProject.after_image_url}
                title={featuredProject.title}
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-brand-900 mb-2">
                  {featuredProject.title}
                </h3>
                <p className="text-brand-600">{featuredProject.description}</p>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Benefits Section */}
      <section className="bg-white py-12 mb-12">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-900 text-center mb-8">
            Why Choose Our {serviceData.name} Services?
          </h2>
          <div className="max-w-3xl mx-auto">
            <ul className="space-y-4">
              {serviceData.benefits.map((benefit, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-nature-600 text-xl mr-3 flex-shrink-0">✓</span>
                  <span className="text-lg text-brand-700">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Additional Projects */}
      {projectsData.length > 1 && (
        <section className="container mx-auto px-4 mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-900 text-center mb-8">
            More {serviceData.name} Projects
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {projectsData.slice(1).map((project) => (
              <div key={project.id} className="bg-white rounded-xl shadow-lg overflow-hidden">
                <BeforeAfterSlider
                  beforeImage={project.before_image_url}
                  afterImage={project.after_image_url}
                  title={project.title}
                />
                <div className="p-4">
                  <h3 className="font-bold text-brand-900">{project.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* CTA Section */}
      <section className="container mx-auto px-4 text-center">
        <div className="bg-brand-800 rounded-xl p-8 md:p-12 max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Need {serviceData.name}?
          </h2>
          <p className="text-brand-200 text-lg mb-6">
            Contact Joe today for a free consultation and estimate
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+17272773366"
              className="bg-water-600 hover:bg-water-700 text-white font-bold py-4 px-8 rounded-lg transition-colors text-lg"
            >
              📞 Call (727) 277-3366
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ServicePage;
